const checkConverSizeError = (body) => {
  // if all request options are set, then we can assume that the error is not due to a missing backend
  try {
    const data = JSON.parse(body);
    const hasEmptyOptions = [
      'from_brand',
      'from_gender',
      'from_unit',
      'product_type',
      'size',
      'to_brand',
      'to_gender',
      'to_unit',
    ].some((key) => {
      return data[key] === undefined || data[key] === null || data[key] === '';
    });
    return !hasEmptyOptions;
  } catch {
    return false;
  }
};

export const isKnownBackendError = (url, options, errorMessage) => {
  // error message has been passed to the server
  if (errorMessage?.length > 0) {
    return true;
  }

  if (url === '/web-api/v1/convert_size') {
    return checkConverSizeError(options.data);
  }

  return false;
};
